export default __webpack_public_path__ + "static/media/TOP-P14-open-3mm.4660184a.dwg";